export default __webpack_public_path__ + "static/media/bottombg03@2x.5815da85.png";